import { z } from "zod";
import { emailField, requiredString } from "@/core/schemas/common";

export const loginSchema = z.object({
  email: emailField,
  password: requiredString("Password"),
});

export type LoginFormValues = z.infer<typeof loginSchema>;
